import { cn } from '../lib/cn';

export interface SupportAccountLabelProps {
  /** The customer being worked in, or empty when none is selected yet. */
  accountName?: string;
  className?: string;
}

/**
 * Stands in for `<AccountSwitcher>` in the sidebar header during a Stratum
 * support session — same slot, same typography, so the brand block keeps its
 * alignment instead of collapsing to nothing.
 *
 * <p>
 * READ-ONLY, deliberately. It matches the switcher's look but has no dropdown:
 * customers are chosen in the support bar, and a second control offering to
 * change the same thing is how two indicators end up disagreeing. This one
 * only reports.
 * </p>
 *
 * <p>
 * Tinted rose to match the support bar, so the two obviously belong to each
 * other and neither can be mistaken for ordinary app chrome.
 * </p>
 */
export function SupportAccountLabel({ accountName, className }: SupportAccountLabelProps) {
  const selected = Boolean(accountName);

  return (
    <div
      className={cn('flex w-full items-center gap-1.5 text-sm', className)}
      title={accountName || undefined}
    >
      <span
        className={cn(
          'h-1.5 w-1.5 flex-shrink-0 rounded-full',
          selected ? 'bg-rose-500' : 'bg-slate-600',
        )}
        aria-hidden="true"
      />
      <span className={cn('truncate', selected ? 'text-rose-300' : 'text-slate-500')}>
        {accountName || 'No customer selected'}
      </span>
    </div>
  );
}
